import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './NotFound.css';
import routeLocations from '../../utility/route-locations';
import { selectSessionUser } from '../../state/ui/application/sessionUiReducer';


/*
  If the page cannot be found, this page should be displayed.
  The (optional) returnLocation prop defines where the return link should lead to.
  This is the root of the website by default.
*/
export default function NotFound() {
  const user = useSelector(selectSessionUser);
  const returnLocation = user ? routeLocations.dashboard : routeLocations.landing;

  return (
    <div className="not-found-wrapper">
      <div>
        <h1 className="not-found-error">Not Found!</h1>
        <Link className="not-found-link" to={returnLocation}>
          Get me home!
        </Link>
      </div>
    </div>
  );
}
